export const FIELDS = {

  ID: 'id',
  COMPANY_ID: 'companyId',
  CONTACT_ID: 'contactId',
  WORKFLOW_ITEM_ID: 'workflowItemId',
  REQUIREMENT_DATE: 'requirementDate',
  REQUIREMENT_NUMBER: 'requirementNumber',
  REFERAL_SOURCE_ID: 'referalSourceId',
  CURRENCY_TYPE_ID: 'currencyTypeId',
  EXCHANGE_RATE: 'exchangeRate',
  SALES_PERSON_USER_ID: 'salesPersonUserId',
  REQUIREMENT_FAX: 'requirementFax',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  CUSTOMER_NOTE: 'customerNote',
  ACTIVE: 'active',
  REF_ID: 'refID',
  COMPANY_NAME: 'companyName',
  CONTACT_FIRST_NAME: 'contactFirstName',
  CONTACT_LAST_NAME: 'contactLastName',
  CONTACT_FULL_NAME: 'contactFullName',
  WORK_FLOW_ITEM_NAME: 'workFlowItemName',
  REFERAL_SOURCE_NAME: 'referalSourceName',
  CURRENCY_TYPE_NAME: 'currencyTypeName',
  CURRENCY_SYMBOL: 'currencySymbol',
  SALES_PERSON_USER_FULL_NAME: 'salesPersonUserFullName',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  RFQDATE: 'rfqDate',
};